import Axios from "../utils/axiosInstance";

// API for adding desk/shift details on start shift
export const postAddDeskDetails = (payload, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.post("/User/adddestDetails", payload, {
    headers: headers || {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

// API for getting desk/attendance details against username
export const getDeskDetailsAgainstUserName = (username, headers) => {
  let token = sessionStorage.getItem("token");
  let dynamicUser = username || sessionStorage.getItem("userName") || "";
  return Axios.get("/User/getdeskdetailsAgainstUserName", {
    params: { username: dynamicUser },
    headers: headers || { Authorization: `Bearer ${token}` },
  });
};

// API for getting desktop details for manager/admin directory table
export const getDestDetails = (role, fkUserId, headers) => {
  let token = sessionStorage.getItem("token");
  let queryRole = role || sessionStorage.getItem("role") || "Employee";
  let queryUserId =
    fkUserId !== undefined && fkUserId !== null
      ? fkUserId
      : (sessionStorage.getItem("pkUserId") || "");
  return Axios.get("/User/getdestDetails", {
    params: { role: queryRole, fkUserId: queryUserId },
    headers: headers || { Authorization: `Bearer ${token}` },
  });
};

// API for getting employee user list against role:
// Endpoint: https://petropulse-test.petrotec.com/User/employeuserlistagainstrole or /User/getdestDetails?role=Employee&fkUserId=163ad82d-9f74-4745-bc7c-223ca13fc33
export const getEmployeeUserListAgainstRole = async (role = "Employee", fkUserId, headers) => {
  let token =
    sessionStorage.getItem("token") ||
    localStorage.getItem("token") ||
    sessionStorage.getItem("Token") ||
    localStorage.getItem("Token");
  let queryRole = role || "Employee";
  let sessionUserId =
    sessionStorage.getItem("pkUserId") ||
    localStorage.getItem("pkUserId") ||
    sessionStorage.getItem("userId") ||
    localStorage.getItem("userId");
  let queryUserId =
    fkUserId !== undefined && fkUserId !== null && String(fkUserId).trim() !== ""
      ? fkUserId
      : (sessionUserId || "163ad82d-9f74-4745-bc7c-223ca13fc33");

  const authHeaders = headers || (token ? { Authorization: token.startsWith("Bearer ") ? token : `Bearer ${token}` } : {});

  // 1. Try GET /User/employeuserlistagainstrole with role & fkUserId
  try {
    const res = await Axios.get("/User/employeuserlistagainstrole", {
      params: { role: queryRole, fkUserId: queryUserId },
      headers: authHeaders,
    });
    if (res && res.data) {
      return res;
    }
  } catch (err1) {
    console.warn("Call to /User/employeuserlistagainstrole with fkUserId failed:", err1?.message || err1);
  }

  // 2. Try GET /User/employeuserlistagainstrole with role only
  try {
    const res = await Axios.get("/User/employeuserlistagainstrole", {
      params: { role: queryRole },
      headers: authHeaders,
    });
    if (res && res.data) {
      return res;
    }
  } catch (err2) {
    console.warn("Call to /User/employeuserlistagainstrole with role only failed:", err2?.message || err2);
  }

  // 3. Fallback to /User/getdestDetails?role=Employee&fkUserId=...
  return Axios.get("/User/getdestDetails", {
    params: { role: queryRole, fkUserId: queryUserId },
    headers: authHeaders,
  });
};

export const employeuserlistagainstrole = getEmployeeUserListAgainstRole;
export const getemployeuserlistagainstrole = getEmployeeUserListAgainstRole;

// API for ending shift
export const postShiftEnd = (username, endTime, headers) => {
  let token = sessionStorage.getItem("token");
  let dynamicUser = username || sessionStorage.getItem("userName") || "";
  return Axios.post(
    "/User/shiftEnd",
    {},
    {
      params: { username: dynamicUser, endTime },
      headers: headers || {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

// API for updating employee break time
export const updateBreakTime = (username, breakTime, headers) => {
  let token = sessionStorage.getItem("token");
  let dynamicUser = username || sessionStorage.getItem("userName") || "";
  return Axios.post(
    "/User/updateBreakTime",
    {},
    {
      params: { username: dynamicUser, breakTime },
      headers: headers || {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  ).catch((postErr) => {
    if (postErr?.response?.status === 405) {
      return Axios.get("/User/updateBreakTime", {
        params: { username: dynamicUser, breakTime },
        headers: headers || { Authorization: `Bearer ${token}` },
      });
    }
    throw postErr;
  });
};

